import type { ButtonHTMLAttributes } from 'react';

type Variant = 'solid' | 'outline' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent';

const VARIANTS: Record<Variant, string> = {
  solid: 'bg-primary text-white hover:bg-primary-shade',
  outline: 'border border-primary text-primary hover:bg-primary/10',
  ghost: 'text-slate-700 hover:bg-black/5',
};

/** Replaces ion-button, including its fill="solid" / fill="outline" variants. */
export function Button({ variant = 'solid', className = '', type = 'button', ...props }: ButtonProps) {
  return <button type={type} className={`${BASE} ${VARIANTS[variant]} ${className}`} {...props} />;
}
